import { prop } from 'ramda'

export const active = prop('active')
export const icon = prop('icon')
export const title = prop('title')
export const message = prop('message')
export const retry = prop('retry')
